


















































































import {Component, Vue} from 'vue-property-decorator';
import Search from "../utility/Search.vue";
import {searchByUser} from "@/endpoints";

Vue.component("v-search", Search);

@Component
export default class Worksheet extends Vue {

    SearchByUser = searchByUser;

    mounted() {
        //this.onDateChange();
    }

    onUserItemSelected(result) {
        //this.refreshUserList(result ? result.id : null);
    }

}
